import bemCssModules from 'bem-css-modules';
import type { VFC } from 'react';
import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

import CategoryButtonItemModuleCss from './CategoryButtonItem.module.css';
import { SiteMap } from '~/constants';
import type { Category } from '~/models/supportCenter';

const block = bemCssModules(CategoryButtonItemModuleCss);

export const CategoryButtonItem: VFC<Category> = ({ CategoryId, Icon, Name }) => {
  const [link, setLink] = useState('');

  useEffect(() => {
    if (SiteMap.Category.To !== undefined) {
      setLink(SiteMap.Category.To(CategoryId));
    }
  }, [CategoryId]);

  return (
    <Link
      className={block()}
      to={link}
    >
      <span className={`${block('icon')} icon ${Icon}`} />
      <p className={block('text')}>{Name}</p>
    </Link>
  );
};
